<template>
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th>zlecenie</th>
          <th>indeks</th>
          <th>nazwa etykiety</th>
          <th>wykrojnik</th>
          <th>wymiar_x</th>
          <th>wymiar_y</th>
          <th>surowiec_handlowy_a</th>
          <th>karta technologiczna</th>
          <th>Akcja</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in zlecenia" :key="index">
          <td>{{ item.zlecprod_idm }}</td>
          <td>{{ item.indeks_etykiety }}</td>
          <td>{{ item.nazwa_etykiety }}</td>
          <td>{{ item.wykrojnik }}</td>
          <td>{{ item.wymiar_x }}</td>
          <td>{{ item.wymiar_y }}</td>
          <td>{{ item.surowiec_handlowy_a }}</td>
          <td><a :href="'/api/karty_technologiczne/'+convert(item.zlecprod_idm)">{{convert(item.zlecprod_idm)}}</a>
          <td>
            <button @click="selectItem(item)">Wybierz</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['zlecenia'],
  methods: {
    selectItem(item) {
      this.$emit('zlecenie-selected', item);
    },
    convert(zlecprod_idm) {
      let arr = zlecprod_idm.trim().split('/')
      let tech   = arr[0].trim()
      let nr_zlec= arr[1].trim()
      let year   = arr[2].trim()

      while(tech.length<4) tech=tech+'_'

      const filename=tech+"_"+nr_zlec+"_"+year+"_____.pdf"  // 4____16781_2023_____.pdf
      return filename;
  }

  }
}
</script>

<style scoped>
.table-container {
  max-height: 300px;
  overflow-y: auto;
  font-size: 12px;
  text-align: left;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: none; /* Remove borders */
  padding: 4px;
}

thead th {
  position: sticky;
  top: 0;
  background: white;
}

tbody tr:hover {
  background-color: #f0f8ff; /* Light bluish color on hover */
}

button {
  padding: 4px 8px;
}
</style>

